import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" width="17" height="14" {...props}><path d="M7.707 1.707A1 1 0 0 0 6.293.293l1.414 1.414zM1 7l-.707-.707a1 1 0 0 0 0 1.414L1 7zm5.293 6.707a1 1 0 0 0 1.414-1.414l-1.414 1.414zm0-13.414l-6 6 1.414 1.414 6-6L6.293.293zm-6 7.414l6 6 1.414-1.414-6-6L.293 7.707zM1 8h16V6H1v2z" /></svg>);